import {
	BaseApiService,
	BaseDeleteDto,
	BaseFindDto,
	BaseFindOneDto,
	BaseUpdateDto
} from "@remar/shared/dist/api/baseApiService";
import { FileVaultFolder } from "@remar/shared/dist/models";

import { URLS } from "../services.constants";

export class FileVaultService extends BaseApiService<
	FileVaultFolder,
	Record<string, unknown>,
	BaseFindDto,
	BaseFindOneDto,
	BaseUpdateDto<Record<string, unknown>>,
	BaseDeleteDto
> {
	constructor(baseUrl: string) {
		super(baseUrl);
	}
}

export const fileVaultFolderService = new FileVaultService(URLS.FILEVAULTFOLDER);
